// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2hBao","fileBtn":"File_fileBtn__2G5ms","closeBtn":"File_closeBtn__xCbsv","fileSelected":"File_fileSelected__1h6fp","disabled":"File_disabled__2ASuF"};